export const environment = {
  local: false,
  des: true,
  pru: false,
  prod: false,
  cloudFrontUrl: 'https://d1i4ki5auo3kcb.cloudfront.net',
  endpoint: '/api/v1/onboarding',
  modyoConfig: {
    baseUrl: 'https://bmm-co.modyo.be',
    spaceId: 'onboardin-g',
    locale: 'es',
    apiToken: 'OhqJFLM0Fb__haJNuarEVqCY7aU1kUlJWsWviGGzyjY',
  },
  auditoriaConfig: {
    path: '/auditoria-trazabilidad',
    habilitado: true,
    timeoutMs: 10000,
    reintentos: 3,
  },
  datosMaestrosConfig: {
    baseUrl: 'https://d2x16cmwgcesse.cloudfront.net',
    basePath: '/api/v1/middleware/datos-maestros',
    timeoutMs: 10000,
  },
  registroUsuarioConfig: {
    path: '/registro-usuario',
    timeoutMs: 15000,
  },
  orquestadorBusConfig: {
    path: '/orquestador-bus',
    timeoutMs: 30000,
  },
  checkpointsRetomaConfig: {
    path: '/checkpoints-retoma',
    timeoutMs: 10000,
  },
  fraudnetConfig: {
    timeoutMs: 5000,
    habilitado: true,
  },
  incodeConfig: {
    allowedOrigin: 'https://sdk.incode.com',
  },
};
